export default __webpack_public_path__ + "assets/images/9c01ad1d6fcb899e212d85a3721c7919.png";